import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './TutorDetail.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import {MyInput} from './Utilities/MyInput';

import MyTooltip from '../components/Utilities/MyTooltip';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function TutorDetail(prop) {	
	const navigate = useNavigate();
	
	let tutorId = prop.tutorId;
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [displayName, setDisplayName] = useState("");
	const [zoomLink, setZoomLink] = useState("");
	const [username, setUsername] = useState("");
	
	const fetchData = async () => {
		getData('tutorApi/getTutorBasicById?tutorId=' + tutorId, navigate)
		.then(res => {
				let data = res.data;
				setDisplayName(data.displayName);
				setUsername(data.username);
				setZoomLink(data.zoomLink);
				setFetchCompleted(true);
			}
		);
	}
	
	const updateZoomLink = async () => {
		let obj = { tutorId, zoomLink }
	
		postData("tutorApi/updateZoomLink", obj, navigate); 
	}
	
	const updateDisplayName = async () => {
		let obj = { tutorId, displayName }
	
		postData("tutorApi/updateDisplayName", obj, navigate); 
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div>
		<div style={{display:"flex", flexDirection:"column", alignItems:"start", gap:"2px"}}>
			<div style={style.row}>
				<div style={{fontWeight:"bold"}}>ID:</div>
				<div>{tutorId}</div>
			</div>
			<div style={style.row}>
				<div style={{fontWeight:"bold"}}>Username:</div>
				<div>{username}</div>
			</div>
			<div style={style.row}>
				<div style={{fontWeight:"bold"}}>Display Name:</div>
				<MyInput inputLabel={""} dataInput={displayName} changeAction={setDisplayName} />		
				<div>
					<GreenButton overrideStyle={{padding:"2px", fontSize:"14px"}} isEnabled={true} clickedAction={()=>{updateDisplayName()}} bText={"Update"} />
				</div>
			</div>
			<div style={style.row}>
				<div style={{fontWeight:"bold"}}>Zoom Link:</div>
				<MyInput inputLabel={""} dataInput={zoomLink} changeAction={setZoomLink} />		
				<div>
					<GreenButton overrideStyle={{padding:"2px", fontSize:"14px"}}  isEnabled={true} clickedAction={()=>{updateZoomLink()}} bText={"Update"} />
				</div>
			</div>
		</div>
	
	</div>);
	
}

const style={
	row:{display:"flex", flexDirection:"row", gap:"10px", alignItems:"center"}
	
}
